
import tlMessages from '../locales/tl_TL';

const TlLang = {
  messages: {
    ...tlMessages,
  },
  locale: 'tl-TL',
 
};
export default TlLang;
